import requests from "./httpServices.js";

class BrandKitService {
  async getActiveBrandKit() {
    try {
      const response = await requests.get('/brand-kits/active');
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async listBrandKits(search = null) {
    try {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      const query = params.toString();
      const url = `/brand-kits${query ? `?${query}` : ''}`;
      const response = await requests.get(url);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async createBrandKit(data) {
    try {
      const response = await requests.post('/brand-kits', data);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async updateBrandKit(id, data) {
    try {
      const response = await requests.put(`/brand-kits/${id}`, data);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async deleteBrandKit(id) {
    try {
      const response = await requests.delete(`/brand-kits/${id}`);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async setDefault(id) {
    try {
      const response = await requests.put(`/brand-kits/${id}/default`);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async removeDefault(id) {
    try {
      const response = await requests.delete(`/brand-kits/${id}/default`);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async setGlobalDefault(id) {
    try {
      const response = await requests.put(`/brand-kits/${id}/global-default`);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async removeGlobalDefault(id) {
    try {
      const response = await requests.delete(`/brand-kits/${id}/global-default`);
      return response;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  handleError(error) {
    if (error.response?.data) {
      const { message, errors } = error.response.data;
      if (errors && typeof errors === "object") {
        const errorMessages = Object.values(errors).flat();
        return new Error(errorMessages.join(", "));
      }
      if (message) {
        return new Error(message);
      }
    }
    if (error.message) {
      return new Error(error.message);
    }
    return new Error("An unexpected error occurred");
  }
}

const brandKitService = new BrandKitService();
export default brandKitService;
